import { render, staticRenderFns } from "./RevenueType.vue?vue&type=template&id=878eb422&"
import script from "./RevenueType.vue?vue&type=script&lang=js&"
export * from "./RevenueType.vue?vue&type=script&lang=js&"
import style0 from "./RevenueType.vue?vue&type=style&index=0&id=878eb422&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports